import { QueryKey } from '@tanstack/react-query';
import { apiBaseKeys, apiKeys, isRootOperatorSearchQueryKey } from './api.routes';

const ROOT_DATA_BASE_KEYS = [apiBaseKeys.trainingPrograms, apiBaseKeys.operators];

export const isSettingsQueryKey = ([baseKey]: QueryKey): boolean =>
  baseKey === apiBaseKeys.settings;

export const isRootListQueryKey = (queryKey: QueryKey): boolean =>
  (queryKey[0] === apiBaseKeys.trainingPrograms &&
    queryKey[1] === apiKeys.trainingPrograms.getAll()) ||
  isRootOperatorSearchQueryKey(queryKey);

export const isWorkflowQueryKey = (queryKey: QueryKey): boolean =>
  ROOT_DATA_BASE_KEYS.includes(queryKey[0] as string) && !isRootListQueryKey(queryKey);

export const isViewQueryKey = ([baseKey]: QueryKey): boolean => baseKey !== apiBaseKeys.languages;
